import React, {useState, useEffect, useContext} from 'react'
import fetchHook from '../../hooks/fetchMSSQL-hook'
import { NavigationContext } from '../../context/navigation-context'
import moment from 'moment'
import { Link, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import NoResults from '../../components/NoResults/NoResults'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

export default function Promotions() {
    const [promotions, setPromotions] = useState([]),
    {setHeaderData} = useContext(NavigationContext),
    {fetchMssqlApi} = fetchHook(),
    params = useParams(),
    [promotionType, setPromotionType] = useState("baskets"),
    history = useHistory()

    const defaultFilter = {
        sortBy: "none"
    }

    const [filter, setFilter] = useState(defaultFilter)

    const sortDefaults = {
        StartDateTime: "DESC",
        EndDateTime: "DESC",
        Price: "DESC",
        SubscribeProducts: "DESC",
        Created: "DESC"
    }

    const getSortState = () => {
        const [field, dir] = String(filter.sortBy || "").split("|")
        return { field, dir: (dir || "").toUpperCase() }
    }

    const sortState = getSortState()

    const arrow = (field) => {
        if (sortState.field !== field) return ""
        return sortState.dir === "ASC" ? " ▲" : " ▼"
    }

    const getPromotions = () => {
            promotionType === "baskets" && fetchMssqlApi('promotions-basket', { params: { sortBy: filter.sortBy } }, 
        res => setPromotions(res))
    }

    const handleHeaderSort = (field) => {
        const [curField, curDirRaw] = String(filter.sortBy || "").split("|")
        const curDir = (curDirRaw || "").toUpperCase()

        let nextDir
        if (curField === field) {
            nextDir = curDir === "ASC" ? "DESC" : "ASC"
        } else {
            nextDir = sortDefaults[field] || "ASC"
        }

        const next = { ...filter, sortBy: `${field}|${nextDir}` }
        setFilter(next)
        getPromotions(next)
    }

    useEffect(() => {
        setHeaderData({text: "Promocje"})
    }, [])

    useEffect((() => {
        history.replace(`/promotions/${promotionType}`)
        getPromotions(filter)
    }), [promotionType])

    return (
        <div>
            <ul className='nav nav-tabs machine-tabs mb-3'>
                <li className="nav-item">
                    <button
                    onClick={() => setPromotionType("baskets")}
                    className={`nav-link btn active`}
                    tabIndex="0">
                        Zestawy
                    </button>
                </li>
                {/* <li className="nav-item">
                    <button
                        onClick={() => setPromotionType("adasdasd")}
                        className={`nav-link btn`}
                        tabIndex="0">
                    </button>
                </li> */}

            </ul>
            {promotions.length ? (
                
                <div className='card'>
                    <div className='card-header'>
                        <div className='d-flex justify-content-between'>
                            <div></div>
                            <Link to={`/promotion/basket/0`} className="btn text-nowrap btn-outline-secondary mt-1 mb-1"><i className="fas fa-plus" /></Link>
                        </div>
                    </div>
                    <div className='overflow-auto custom-scroll' style={{maxHeight: "60vh"}}>
                        <table className='table table-striped'>
                            <thead>
                                <tr className='headers-color text-center headers-color'>
                                    <td style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("StartDateTime")}>
                                        Start{arrow("StartDateTime")}
                                    </td>
                                    <td style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("EndDateTime")}>
                                        Koniec{arrow("EndDateTime")}
                                    </td>
                                    <td style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("Price")}>
                                        Cena{arrow("Price")}
                                    </td>
                                    <td style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("SubscribeProducts")}>
                                        Ilość produktów w zestawie{arrow("SubscribeProducts")}
                                    </td>
                                    <td style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("Created")}>
                                        Stworzona{arrow("Created")}
                                    </td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {promotions.map((promotion, idx) => (
                                    <tr key={idx}>
                                        <td className='text-center'>{moment(promotion.StartDateTime).format('YYYY-MM-DD HH:MM')} </td>
                                        <td className='text-center'>{moment(promotion.EndDateTime).format('YYYY-MM-DD HH:MM')}</td>
                                        <td className='text-center'>{Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(promotion.Price)}</td>
                                        <td className='text-center'>
                                            {promotion.SubscribeProducts}

                                        </td>
                                        <td className='text-center'>{promotion.Created}</td>
                                        <td className='d-flex justify-content-end mb-2 border-0'>
                                            <Link to={`/promotion/basket/${promotion.BasketId}`} className="btn btn-outline-primary btn-sm mt-2 mr-2">
                                                Edytuj
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <div className='text-center'>

                    <NoResults/>
                    <Link className='mt-5' to="/promotion/basket/0">
                        Dodaj promocję
                    </Link>
                </div>
            )}
        </div>
    )  
}